import { createFileRoute } from "@tanstack/react-router";
import { LearnArticlePage } from "#/features/learn/components/learn-article-page";
import { learnPostQueryOptions } from "#/features/learn/hooks/use-learn-post";
import { learnPostsQueryOptions } from "#/features/learn/hooks/use-learn-posts";
import { routeHeadFromContext } from "#/lib/route-head";

export const Route = createFileRoute("/learn/$slug")({
	// SSR: 글(+ 관련 글 링크용 목록)을 캐시에 채워 서버 HTML에 본문이 실린다.
	// 클라이언트 내비게이션은 캐시 히트(staleTime 1h). 목록은 실패해도 글을 막지 않는다.
	loader: async ({ context: { queryClient, locale }, params: { slug } }) => {
		const [post] = await Promise.all([
			queryClient.ensureQueryData(learnPostQueryOptions(slug, locale)),
			queryClient.prefetchQuery(learnPostsQueryOptions(locale)),
		]);
		return post;
	},
	// 글 메타 + Article JSON-LD는 loaderData가 필요해 루트 head가 아닌 여기서 —
	// 루트 head는 learn 글 경로를 건너뛴다(isLearnArticlePath).
	head: ({ match, params, loaderData }) =>
		routeHeadFromContext(match.context, match.pathname, {
			learnSeo: { slug: params.slug, post: loaderData ?? null },
		}),
	component: LearnArticleRoute,
});

function LearnArticleRoute() {
	const { slug } = Route.useParams();
	return <LearnArticlePage slug={slug} />;
}
